import { styled } from '@styles/stitches';

export const VerticalContainer = styled('div', {
  width: '100vw',
  marginBottom: '$2',

  '@bp1': {
    width: '50vw',
    margin: '0 auto',
  },

  '@bp2': {
    width: '718px',
  },

  '& > *': {
    display: 'block',
    marginBottom: '$2',
  },
});

export const NewCollection = styled('button', {
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  overflow: 'hidden',

  i: {
    transition: '$medium',
    opacity: 0.5,
  },

  '&:hover': {
    i: {
      opacity: 1,
    },
  },

  '&:focus': {
    outline: 0,

    i: {
      opacity: 1,
    },
  },
});
